import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function BillingWarning({ plan }) {
  const [loading, setLoading] = useState(false);
  if (!plan?.billing_warning) return null;

  const openPortal = async () => {
    setLoading(true);
    try {
      const r = await api.billingPortal(window.location.href);
      if (r?.url) window.location.href = r.url;
    } catch (e) {
      toast.error(
        e?.response?.data?.detail ||
          "Could not open billing portal. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="billing-warning-banner"
      className="border border-rose-500/40 bg-rose-500/5 rounded-sm p-3 flex items-start gap-3"
    >
      <AlertTriangle
        className="h-4 w-4 text-rose-600 shrink-0 mt-0.5"
        strokeWidth={2}
      />
      <div className="flex-1 min-w-0 text-sm text-rose-700">
        <span className="font-medium">Payment failed.</span>{" "}
        Please update your billing details to continue Pro access.
      </div>
      {plan.has_stripe_customer ? (
        <Button
          size="sm"
          variant="outline"
          onClick={openPortal}
          disabled={loading}
          data-testid="billing-warning-update-btn"
          className="rounded-sm border-rose-500/40 text-rose-700 hover:bg-rose-500/10"
        >
          Update billing
        </Button>
      ) : null}
    </div>
  );
}
